import React, { PropTypes } from 'react';
import { FormattedNumber, FormattedPlural } from 'react-intl';

import { Link } from 'react-router';

import UserImage from 'AppComponents/UserImage';

import './styles.scss';


const ReviewUser = ({ user }) => {
  if (user) {
    const numReviews = user.num_charger_reviews || 0 + user.num_place_reviews || 0;

    return (
      <div className='user' styleName='user'>

        <Link to={`/user/${user.username}/`}>
          <UserImage user={user} styleName='profile-photo' />

          <p className='username'>
            { user.public_name }
          </p>
        </Link>

        { numReviews ?
          <p className='num-reviews'>
            <FormattedNumber value={numReviews} />&nbsp;
            <FormattedPlural
              value={numReviews}
              one='review'
              other='reviews'
            />
          </p>
        : null }

      </div>
    );
  }
  return (
    <div className='user deleted' styleName='user'>

      <UserImage user={user} />

      <p className='username'>
        Anonymous
      </p>

    </div>
  );
};

ReviewUser.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    public_name: PropTypes.string,
    num_place_reviews: PropTypes.number,
    num_charger_reviews: PropTypes.number,
  }).isRequired,
};

export default ReviewUser;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/BaseReview/Review/User.jsx